import { yupResolver } from '@hookform/resolvers/yup'
import { useForm } from 'react-hook-form'
import { updateDriverFormSchema } from './update-driver-form.schema'

export const useUpdateDriverForm = () => {
  const form = useForm({
    resolver: yupResolver(updateDriverFormSchema),
    defaultValues: updateDriverFormSchema.cast({}),
  })

  return { form }
}
